import { render, staticRenderFns } from "./Sendby.vue?vue&type=template&id=328d6846&scoped=true&"
import script from "./Sendby.vue?vue&type=script&lang=js&"
export * from "./Sendby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d6846",
  null
  
)

export default component.exports